import React from 'react';
import { observer } from 'mobx-react-lite';
import { cn } from 'src/domains/common/components/utils';
import { MenuItemFiltersPropsType } from 'src/domains/casino/webview/bonus-engine/campaign-list/filters/filters.type';
import { SubMenuItemFilters } from 'src/domains/casino/webview/bonus-engine/campaign-list/filters/SubMenuItemFilters';
import { MenuItemWrapper, SubMenuWrapper } from 'src/domains/common/components/menu-bar/menu-bar';

export const MenuItemFilters = observer(
    ({ label, items, campaignListState, submenuPosition }: MenuItemFiltersPropsType): JSX.Element => {
        return (
            <MenuItemWrapper
                label={label}
                data-test={`filter-item-${label}`}
            >
                <SubMenuWrapper
                    className={cn(
                        'absolute p-1 top-0 mt-0 min-w-40 z-50 hidden group-hover:block',
                        submenuPosition === 'right' ? 'left-full' : 'right-full'
                    )}
                >
                    {items.map((item) => (
                        <SubMenuItemFilters
                            label={label}
                            key={item.key}
                            item={item}
                            campaignListState={campaignListState}
                        />
                    ))}
                </SubMenuWrapper>
            </MenuItemWrapper>
        );
    }
);
